module.exports = __webpack_public_path__ + "img/logo-rrs.7adeb56e.svg";